'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('regenerator-runtime/runtime');
var React = require('react');
var React__default = _interopDefault(React);
var Grid = _interopDefault(require('@material-ui/core/Grid'));
var formsServiceUiValidation = require('@danfoss/forms-service-ui-validation');
var typesafeActions = require('typesafe-actions');
var reactRedux = require('react-redux');
var formsServiceUiTypes = require('@danfoss/forms-service-ui-types');
var axios = _interopDefault(require('axios'));
var ReactDOM = _interopDefault(require('react-dom'));
var ReCAPTCHA = _interopDefault(require('react-google-recaptcha'));
var makeStyles = _interopDefault(require('@material-ui/core/styles/makeStyles'));
var scrollIntoView = _interopDefault(require('scroll-into-view'));
var merge = _interopDefault(require('lodash.merge'));
var redux = require('redux');
var produce = require('immer');
var produce__default = _interopDefault(produce);

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

const SET_VALUE = '@@FORMS_SERVICE_UI/SET_VALUE';
const SET_VALIDATION_ERRORS = '@@FORMS_SERVICE_UI/SET_VALIDATION_ERRORS';
const FORM_LOADED = '@@FORMS_SERVICE_UI/FORM_LOADED';
const SUBMITTING_FORM_DATA = '@@FORMS_SERVICE_UI/SUBMITTING_FORM_DATA';
const FORM_LOAD_ERROR = '@@FORMS_SERVICE_UI/FORM_LOAD_ERROR';
const FORM_SUBMIT_RESPONSE_RECEIVED = '@@FORMS_SERVICE_UI/FORM_SUBMIT_RESPONSE_RECEIVED';
const setFieldValue = payload => typesafeActions.action(SET_VALUE, payload);
const setValidationErrors = payload => typesafeActions.action(SET_VALIDATION_ERRORS, payload);
const formLoaded = payload => typesafeActions.action(FORM_LOADED, payload);
const submittingFormData = () => typesafeActions.action(SUBMITTING_FORM_DATA);
const formLoadError = () => typesafeActions.action(FORM_LOAD_ERROR);
const formSubmitResponseReceived = payload => typesafeActions.action(FORM_SUBMIT_RESPONSE_RECEIVED, payload);

const useReduxState = reactRedux.useSelector;
function useDispatchReduxAction() {
  return reactRedux.useDispatch();
}

const getStringFromUrlObj = obj => {
  let str = `?`;
  for (const i in obj) {
    str += `${i}=${encodeURIComponent(obj[i])}&`;
  }
  return str.slice(0, -1);
};
const safeJSONParse = JSONString => {
  try {
    return JSON.parse(JSONString);
  } catch (error) {
    console.warn(error);
    return null;
  }
};
const parseLanguageCode = culture => {
  let languageCode = 'en';
  if (culture) {
    languageCode = culture.indexOf('-') ? culture.split('-')[0] : culture;
  }
  return languageCode;
};
const parseCountryCode = culture => {
  if (culture && culture.indexOf('-') !== -1) {
    return culture.split('-')[1];
  }
  return culture;
};
const getFirstOrDefault = (source, defaultValue) => {
  return source && source.length > 0 ? source[0] : defaultValue;
};
const compareString = (a, b, ignoreCase = false) => {
  if (ignoreCase) {
    return a.toLowerCase().localeCompare(b.toLowerCase());
  } else {
    return a.localeCompare(b);
  }
};
const getStringCompareFunction = (key, ignoreCase = false) => {
  return (a, b) => {
    return compareString(a[key], b[key], ignoreCase);
  };
};
const createRandomId = (length = 6) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
const getCookie = cname => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

var CustomerConsent;
(function (CustomerConsent) {
  CustomerConsent["Notified"] = "Notified";
  CustomerConsent["NotNotified"] = "Not Notified";
})(CustomerConsent || (CustomerConsent = {}));

(function (FormTypes) {
  FormTypes["PardotForm"] = "pardotForm";
  FormTypes["ServiceCloudForm"] = "serviceCloudForm";
  FormTypes["DistributorForm"] = "distributorForm";
  FormTypes["DPSDistributorsForm"] = "dpsDistributorsForm";
  FormTypes["ProductInquiryForm"] = "productInquiryForm";
})(exports.FormTypes || (exports.FormTypes = {}));
var ContactTypesWithForm;
(function (ContactTypesWithForm) {
  ContactTypesWithForm["Distributors"] = "distributor";
  ContactTypesWithForm["ServicePartners"] = "service-partner";
  ContactTypesWithForm["DanfossSalesAndServices"] = "danfoss-sales-service-center";
  ContactTypesWithForm["SalesAgents"] = "sales-agent";
  ContactTypesWithForm["SalesRepresentatives"] = "sales-reprensentative";
})(ContactTypesWithForm || (ContactTypesWithForm = {}));
const contactUsFormTypes = [exports.FormTypes.PardotForm, exports.FormTypes.ServiceCloudForm, exports.FormTypes.DistributorForm, exports.FormTypes.DPSDistributorsForm, exports.FormTypes.ProductInquiryForm];
const powerSolutionsSegment = 'DPS';
const getFormAlias = ({
  contactType,
  segments,
  country,
  email
}) => {
  const hasSegmentsArray = segments && segments.length !== 0;
  if (!contactType || !hasSegmentsArray || !country) {
    return null;
  }
  switch (contactType) {
    case ContactTypesWithForm.Distributors:
    case ContactTypesWithForm.ServicePartners:
      if (!email) return null;
      if (segments.indexOf(powerSolutionsSegment) !== -1) {
        return segments.length === 1 ? exports.FormTypes.DPSDistributorsForm : exports.FormTypes.DistributorForm;
      }
      return exports.FormTypes.DistributorForm;
    case ContactTypesWithForm.DanfossSalesAndServices:
      if (segments.indexOf(powerSolutionsSegment) !== -1) {
        return segments.length === 1 ? exports.FormTypes.PardotForm : exports.FormTypes.ServiceCloudForm;
      }
      return exports.FormTypes.ServiceCloudForm;
    case ContactTypesWithForm.SalesAgents:
    case ContactTypesWithForm.SalesRepresentatives:
      if (!email) return null;
      return exports.FormTypes.DistributorForm;
    default:
      return null;
  }
};
const processFormData = (formAlias, formData, additionalData) => {
  if (contactUsFormTypes.indexOf(formAlias) !== -1) {
    return getContactUsFormDataWithExtraFields(formData, additionalData, formAlias);
  }
  return formData;
};
const getContactUsFormDataWithExtraFields = (formData, additionalData, formAlias) => {
  var _Object$values$find, _additionalData$sourc;
  const dataConsentValue = ((_Object$values$find = Object.values(formData).find(item => (item === null || item === void 0 ? void 0 : item.name) === 'Data consent')) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.value) === true;
  const {
    contactName,
    danfossSegment,
    reason,
    sharingSegment
  } = additionalData;
  const targetContactNameField = contactName ? {
    [createRandomId()]: {
      name: 'TargetContactName',
      value: additionalData.contactName
    }
  } : {};
  const sourceURLField = {
    [createRandomId()]: {
      name: 'SourceURL',
      value: `${window.location.href}`
    }
  };
  const sourceChannelField = {
    [createRandomId()]: {
      name: 'SourceChannel',
      value: (_additionalData$sourc = additionalData.sourceChannel) !== null && _additionalData$sourc !== void 0 ? _additionalData$sourc : 'Case from Web'
    }
  };
  const danfossSegmentField = danfossSegment ? {
    [createRandomId()]: {
      name: 'Danfoss segment',
      value: additionalData.danfossSegment
    }
  } : {};
  const reasonField = reason ? {
    [createRandomId()]: {
      name: 'Reason',
      value: additionalData.reason
    }
  } : {};
  const sharingSegmentField = sharingSegment ? {
    [createRandomId()]: {
      name: 'Sharing Segment',
      value: additionalData.sharingSegment
    }
  } : {};
  const consumerConsentField = formAlias === exports.FormTypes.ProductInquiryForm ? {
    [createRandomId()]: {
      name: 'Customer consent',
      value: dataConsentValue ? CustomerConsent.Notified : CustomerConsent.NotNotified
    }
  } : {};
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, formData), targetContactNameField), sourceURLField), sourceChannelField), consumerConsentField), danfossSegmentField), reasonField), sharingSegmentField);
};
const isNonEmptyRow = (row, formState) => {
  return row.fields && row.fields.length && row.fields.some(field => formState.fieldStates[field.fieldId] !== formsServiceUiTypes.FieldDisplayStates.Hidden);
};

class FormsApi {
  constructor(apiDomain, culture) {
    this.formApiPath = '/api/forms/';
    this.httpClient = axios.create({
      baseURL: apiDomain,
      headers: {
        culture
      }
    });
  }
  getForm(formAlias) {
    const recaptchaToken = getCookie(formsServiceUiTypes.RECAPTCHA_BYPASS_COOKIE_NAME);
    const featureTraffiCKey = getCookie(formsServiceUiTypes.FEATURES_TRAFFIC_KEY_COOKIE_NAME);
    const headers = {};
    if (recaptchaToken) {
      // Set recaptchaByPass Token
      headers[formsServiceUiTypes.RECAPTCHA_BYPASS_HEADER] = recaptchaToken;
    }
    if (featureTraffiCKey) {
      // Set featureTrafficKey
      headers[formsServiceUiTypes.FEATURES_TRAFFIC_KEY_HEADER] = featureTraffiCKey;
    }
    return this.httpClient.get(`${this.formApiPath}${formAlias}`, {
      headers
    });
  }
  submitForm(formAlias, formData) {
    const recaptchaToken = getCookie(formsServiceUiTypes.RECAPTCHA_BYPASS_COOKIE_NAME);
    const featureTraffiCKey = getCookie(formsServiceUiTypes.FEATURES_TRAFFIC_KEY_COOKIE_NAME);
    const headers = {};
    if (recaptchaToken) {
      // Set recaptchaByPass Token
      headers[formsServiceUiTypes.RECAPTCHA_BYPASS_HEADER] = recaptchaToken;
    }
    if (featureTraffiCKey) {
      // Set featureTrafficKey
      headers[formsServiceUiTypes.FEATURES_TRAFFIC_KEY_HEADER] = featureTraffiCKey;
    }
    return this.httpClient.post(`${this.formApiPath}${formAlias}`, formData, {
      headers
    });
  }
}

let uniqueRecaptchaContainerName = '';
function FormReCaptcha({
  recaptchaRef,
  token,
  onChange,
  onError
}) {
  React.useEffect(() => {
    uniqueRecaptchaContainerName = `fs-recaptcha-container-${createRandomId()}`;
    return () => {
      // Need to clear grecaptcha badge manually as by default library removes in 5 sec only.
      // Recaptcha element can not be used as selector, as it is cached inside library
      const reCaptchaContainer = document.getElementsByClassName(uniqueRecaptchaContainerName)[0];
      setTimeout(() => {
        if (reCaptchaContainer) {
          reCaptchaContainer.remove();
        }
      });
    };
  }, []);
  const onLoaded = () => {
    const recaptchaBadgeContainer = recaptchaRef.current.captcha.firstChild;
    recaptchaBadgeContainer && recaptchaBadgeContainer.classList.add(uniqueRecaptchaContainerName);
  };
  return ReactDOM.createPortal(React__default.createElement(ReCAPTCHA, {
    asyncScriptOnLoad: onLoaded,
    className: "fs-recaptcha fs-recaptcha-mounted",
    ref: recaptchaRef,
    size: "invisible",
    sitekey: token,
    onChange: onChange,
    onErrored: onError
  }), document.body);
}

/**
 * Returns props for Grid component which will break to single column at specified size.
 * @param breakAt where should it break to single column
 */
function createGridProps({
  oneColumnBreakpoint = 'sm',
  gridSize
}) {
  const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
  const gridProps = {};
  const breakAtIndex = sizes.indexOf(oneColumnBreakpoint);
  sizes.forEach((size, index) => {
    gridProps[size] = index >= breakAtIndex ? gridSize : 12;
  });
  return gridProps;
}

const FormContext = React__default.createContext({
  formId: '',
  fieldComponentMap: {} // defaultFieldComponentMap,
});

var UserActions;
(function (UserActions) {
  UserActions[UserActions["Submit"] = 0] = "Submit";
  UserActions[UserActions["FormControlValueChange"] = 1] = "FormControlValueChange";
})(UserActions || (UserActions = {}));

var styles = {
  fieldset: {
    border: 'none',
    padding: 0,
    margin: 0,
    minWidth: 0
  }
};

const useStyles = makeStyles(styles);
const isCustomMosaicHtmlElement = element => element.tagName.toLowerCase().startsWith('df-');
const FormField = ({
  field,
  row,
  formState,
  oneColumnBreakpoint,
  onFieldClick,
  isPopup
}) => {
  const {
    errors,
    formData,
    submitting,
    lastAction
  } = formState;
  const dispatch = useDispatchReduxAction();
  const controlRef = React.useRef(null);
  const {
    fieldComponentMap
  } = React.useContext(FormContext);
  const classes = useStyles();
  const FieldComponent = fieldComponentMap[field.type];
  React.useEffect(() => {
    const firstError = errors[0];
    if (lastAction !== UserActions.Submit || !firstError) return;
    const isFirstErrorField = field.fieldId === firstError.fieldId;
    if (isFirstErrorField) {
      const formControl = controlRef.current;
      // Element.scrollIntoView with options is not fully supported by all browsers.
      scrollIntoView(formControl, {
        isScrollable: (target, defaultIsScrollable) => {
          if (isPopup && target === window) {
            return false;
          }
          return defaultIsScrollable(target);
        }
      }, () => {
        if (isCustomMosaicHtmlElement(formControl)) {
          formControl.focusElement({
            preventScroll: true
          });
        } else {
          formControl.focus({
            preventScroll: true
          });
        }
      });
    }
  }, [errors, field.fieldId, isPopup, lastAction]);
  const fieldValue = formData[field.fieldId] && formData[field.fieldId].value;
  const error = errors.find(error => error.fieldId === field.fieldId);
  const disabled = formState.fieldStates[field.fieldId] === formsServiceUiTypes.FieldDisplayStates.Disabled;
  const hidden = formState.fieldStates[field.fieldId] === formsServiceUiTypes.FieldDisplayStates.Hidden;
  const automaticGridSize = React.useMemo(() => Math.round(12 / row.fields.length), [row.fields.length]);
  const gridProps = React.useMemo(() => createGridProps({
    oneColumnBreakpoint,
    gridSize: field.gridSize || automaticGridSize
  }), [oneColumnBreakpoint, field, automaticGridSize]);
  const setValueHandler = React.useCallback((value, title) => {
    dispatch(setFieldValue({
      field,
      value,
      title
    }));
  }, [dispatch, field]);
  const onFieldClickHandler = React.useCallback(e => onFieldClick(e, field), [onFieldClick, field]);
  if (!FieldComponent) {
    return React__default.createElement("div", {
      "data-error": `field component for ${field.type} missing!`
    });
  }
  return !hidden ? React__default.createElement(Grid, _objectSpread2({
    item: true
  }, gridProps), React__default.createElement("fieldset", {
    disabled: disabled,
    hidden: hidden,
    className: classes.fieldset
  }, React__default.createElement(FieldComponent, _objectSpread2(_objectSpread2({
    value: fieldValue
  }, field), {}, {
    error: Boolean(error),
    errorMessage: error ? error.message : null,
    hidden: hidden,
    disabled: disabled,
    isFormSubmitting: submitting,
    controlRef: controlRef,
    onClick: onFieldClickHandler,
    setValue: setValueHandler
  })))) : null;
};

const optionalFnCallback = () => undefined;
let formSubmissionGuardPassed = false;
function RenderForm(props) {
  const {
    className,
    formAlias,
    culture,
    apiDomain,
    gridSpacing,
    oneColumnBreakpoint,
    isPopup = false,
    additionalFormData = {
      contactId: '',
      contactName: '',
      sourceChannel: 'Case from Web'
    },
    onFormLoadStart = optionalFnCallback,
    onFormLoadFailure = optionalFnCallback,
    onFormLoadSuccess = optionalFnCallback,
    onFormSubmit = optionalFnCallback,
    onSuccess = optionalFnCallback,
    onValidationError = optionalFnCallback,
    onGenericError = optionalFnCallback,
    onFieldClick = optionalFnCallback
  } = props;
  const reCaptchaRef = React.useRef(null);
  const [formsApi] = React.useState(new FormsApi(apiDomain, culture));
  const formState = useReduxState(state => state.form);
  const {
    loadingForm,
    form,
    formData,
    submitting
  } = formState;
  const isFormLoaded = !loadingForm && form;
  const dispatch = useDispatchReduxAction();
  const reCaptcha = isFormLoaded ? form.recaptcha : null;
  React.useEffect(() => {
    onFormLoadStart();
    formsApi.getForm(formAlias).then(response => {
      const form = response.data;
      dispatch(formLoaded({
        form
      }));
      onFormLoadSuccess();
    }).catch(error => {
      dispatch(formLoadError());
      onFormLoadFailure(error);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formAlias]);
  const submitFormGuard = event => {
    event.preventDefault();
    if (submitting) return;
    onFormSubmit(event);
    const validationErrors = formsServiceUiValidation.validateForm({
      form,
      formData
    });
    if (validationErrors.length) {
      onValidationError(validationErrors);
      return dispatch(setValidationErrors({
        errors: validationErrors
      }));
    }
    if (reCaptcha !== null && reCaptcha !== void 0 && reCaptcha.enabled) {
      formSubmissionGuardPassed = true;
      performReCaptchaCheck();
    } else {
      submitForm();
    }
  };
  const performReCaptchaCheck = () => {
    const captchaEl = reCaptchaRef.current;
    const reCaptchaInitialized = captchaEl.getWidgetId() !== null;
    if (reCaptchaInitialized) {
      captchaEl.execute();
    } else {
      /*
        When recaptcha widget is not initialized due to network issues
        we send form with empty token. This should result with error response from BE.
      */
      submitForm();
    }
  };
  const submitForm = async reCaptchaData => {
    const submitFormData = {
      formData: processFormData(formAlias, formData, additionalFormData),
      additionalData: _objectSpread2(_objectSpread2({}, additionalFormData), reCaptchaData && {
        reCaptchaData
      })
    };
    dispatch(submittingFormData());
    try {
      const response = await formsApi.submitForm(formAlias, submitFormData);
      const data = response.data;
      const validationErrors = data.errors;
      const workflowError = !data.success && !data.workflowSuccess;
      dispatch(formSubmitResponseReceived(data));
      if (validationErrors && validationErrors.length) {
        onValidationError(validationErrors, true);
      } else if (workflowError) {
        onGenericError();
      } else {
        onSuccess();
      }
    } catch (error) {
      onGenericError(error);
    }
    formSubmissionGuardPassed = false;
  };
  const onReCaptchaSuccess = token => {
    const reCaptchaData = generateReCaptchaData(token);
    submitForm(reCaptchaData);
  };
  /*
    When recaptcha errored (most likely due to network issues) and form validation already
    passed we will send form with empty token. This should result with error response from BE.
  */
  const onReCaptchaError = () => {
    if (formSubmissionGuardPassed) {
      const reCaptchaData = generateReCaptchaData();
      submitForm(reCaptchaData);
    }
  };
  const generateReCaptchaData = (token = '') => {
    return {
      name: 'g-recaptcha-response',
      value: token
    };
  };
  return isFormLoaded ? React__default.createElement("div", {
    className: className
  }, React__default.createElement("form", {
    onSubmit: submitFormGuard
  }, React__default.createElement("div", {
    className: "fs-form-sections"
  }, form.sections.filter(section => section.rows.length > 0).map((section, sectionIndex) => React__default.createElement("div", {
    key: sectionIndex,
    className: "fs-form-section"
  }, section.rows.map((row, rowIndex) => isNonEmptyRow(row, formState) && React__default.createElement(Grid, {
    key: rowIndex,
    container: true,
    spacing: gridSpacing >= 0 ? gridSpacing : 2,
    className: "fs-grid-row"
  }, row.fields.map((field, fieldIndex) => React__default.createElement(FormField, {
    key: fieldIndex,
    row: row,
    field: field,
    formState: formState,
    oneColumnBreakpoint: oneColumnBreakpoint,
    onFieldClick: onFieldClick,
    isPopup: isPopup
  }))))))), reCaptcha.enabled && React__default.createElement(FormReCaptcha, {
    recaptchaRef: reCaptchaRef,
    token: reCaptcha.token,
    onChange: onReCaptchaSuccess,
    onError: onReCaptchaError
  }))) : null;
}

const apiGet = (apiUrl, params, headers) => {
  const requestParams = {
    method: 'get',
    responseType: 'json',
    url: apiUrl + getStringFromUrlObj(params)
  };
  if (headers) {
    requestParams.headers = headers;
  }
  return axios(requestParams);
};

class StorageWithExpiration {
  constructor(storage) {
    this.storage = null;
    this.defaultExpirationTime = 7200000; // 2 hours in milliseconds
    this.expirationKeyPrefix = '__expired_storage__';
    this.storage = storage;
  }
  setDataToStorage(key, value, expirationTime = this.defaultExpirationTime) {
    this.storage.setItem(key, value);
    this.setExpirationData(key, expirationTime);
  }
  getDataFromStorage(key) {
    if (this.isTimeExpired(key)) {
      this.removeDataFromStorage(key);
      return;
    }
    return this.storage.getItem(key);
  }
  setExpirationData(key, expirationTime) {
    const expirationMoment = Date.now() + expirationTime;
    this.storage.setItem(this.expirationKeyPrefix + key, expirationMoment.toString());
  }
  isTimeExpired(key) {
    const expiredTime = this.storage.getItem(this.expirationKeyPrefix + key);
    if (expiredTime) {
      const expiredTimeInMs = parseInt(expiredTime, 10);
      return Date.now() > expiredTimeInMs;
    }
  }
  removeDataFromStorage(key) {
    this.storage.removeItem(key);
    this.storage.removeItem(this.expirationKeyPrefix + key);
  }
}

class BaseApi {
  constructor(config) {
    this.storageWithExpiration = null;
    this.config = config;
    this.initializeStorageWithExpiration();
  }
  getData(params = null) {
    const cachedData = this.getStoredData(params);
    if (cachedData) {
      return Promise.resolve(cachedData);
    }
    return this.loadData(params);
  }
  loadData(params) {
    return this.callApi(this.config.url, params).then(data => {
      this.setDataToStorage(data, params);
      return data;
    });
  }
  callApi(url, params) {
    const headers = this.createHeaders();
    return apiGet(url, params, headers).then(response => {
      if (response.status !== 200) {
        this.throwException(response.statusText, response);
      }
      return response.data;
    }).catch(reason => {
      this.throwException(reason.message, reason.response);
    });
  }
  getStoredData(params) {
    if (this.canUseStorage()) {
      const jsonData = this.storageWithExpiration.getDataFromStorage(this.config.storageKey);
      return jsonData ? this.deserialize(jsonData, params) : null;
    }
    return null;
  }
  setDataToStorage(data, params) {
    if (this.canUseStorage()) {
      const dataToStore = this.serialize(data, params);
      if (dataToStore) {
        const {
          storageKey,
          storageExpirationTime
        } = this.config;
        this.storageWithExpiration.setDataToStorage(storageKey, dataToStore, storageExpirationTime);
      }
    }
  }
  initializeStorageWithExpiration() {
    if (this.config && this.config.storage) {
      this.storageWithExpiration = new StorageWithExpiration(this.config.storage);
    }
  }
  canUseStorage() {
    return this.storageWithExpiration && !!this.config.storageKey;
  }
  throwException(message, responseData, name = '') {
    const apiError = new Error(message);
    apiError.name = name;
    apiError.responseData = responseData;
    throw apiError;
  }
  createHeaders() {
    return null;
  }
  serialize(data, params) {
    return JSON.stringify(data);
  }
  deserialize(data, params) {
    return safeJSONParse(data);
  }
}

class CountryApi extends BaseApi {
  constructor(config) {
    super(config);
  }
  // Load countries from location api - GET /api/countries
  loadCountries(languageCode) {
    const params = {
      language: languageCode
    };
    return this.getData(params).then(data => {
      return data;
    });
  }
  callApi(url, params) {
    const urlWithParams = this.buildUrl(url, params);
    return super.callApi(urlWithParams, params);
  }
  buildUrl(url, params) {
    return `${new URL(url).origin}${CountryApi.API_PATH}`;
  }
}
CountryApi.API_PATH = '/api/location/countries';

class BaseLocationService {
  get languageCode() {
    const languageCode = parseLanguageCode(this.config.culture);
    if (parseCountryCode(this.config.culture).toLowerCase() === 'tw') {
      return `${languageCode}-HANT`;
    }
    return languageCode;
  }
  get serviceName() {
    return 'BaseLocationService';
  }
  constructor(config) {
    this.config = config;
    this.parseCountryCode = countryCode => {
      let result = '';
      if (countryCode) {
        result = countryCode.indexOf(':') !== -1 ? countryCode.split(':')[1] : countryCode;
      }
      return result;
    };
    this.filterOutInvalidTranslation = translations => {
      return translations.filter(translation => {
        const isNotFulfilled = !translation.code || !translation.translation;
        if (isNotFulfilled) {
          console.warn(`[${this.serviceName}]: Not all data is set for item: ${JSON.stringify(translation)}`);
        }
        return !isNotFulfilled;
      });
    };
    this.mapItemsToUIModel = items => {
      if (!items) return null;
      return items.map(item => {
        return this.createSelectOptionItem(item);
      });
    };
    this.createSelectOptionItem = info => {
      return {
        title: info.name,
        value: info.code
      };
    };
  }
  createLocaleStorageKey(prefix) {
    return `${prefix}_${this.config.culture}`;
  }
  createDefaultStorageKey(prefix) {
    return `${prefix}_default`;
  }
  getTranslationForItem(translations, item) {
    const matchedTranslation = translations.filter(translateInfo => translateInfo.code === item.code).map(translateInfo => translateInfo.translation).filter(Boolean);
    return getFirstOrDefault(matchedTranslation, item.name || item.code);
  }
}

class CountryService extends BaseLocationService {
  get serviceName() {
    return 'CountryService';
  }
  constructor(config) {
    super(config);
    this.storageKey = 'countriesInfo';
    this.getDataForSelectOptions = () => {
      return this.getData().then(countries => {
        const result = this.mapItemsToUIModel(countries);
        if (result) {
          result.sort(getStringCompareFunction('title'));
        }
        return result;
      });
    };
    this.getData = () => {
      const language = this.languageCode;
      return this.countryApi.loadCountries(language).then(this.mapStatesApiDataToLocationInfoModel);
    };
    this.mapStatesApiDataToLocationInfoModel = data => {
      const countries = data.value;
      return countries.map(country => {
        return {
          code: country.alpha2,
          name: country.name,
          region: country.region,
          subRegion: country.subregion
        };
      });
    };
    this.countryApi = new CountryApi({
      storage: sessionStorage,
      storageKey: this.createLocaleStorageKey(this.storageKey),
      url: config.apiUrl
    });
  }
}

const CountryField = React.memo(({
  fieldId,
  name,
  placeholder,
  label,
  hint,
  setValue,
  onClick,
  value = '',
  error,
  errorMessage,
  disabled,
  required,
  isSearchable,
  hidden,
  controlRef
}) => {
  const {
    fieldComponentMap,
    culture,
    apiDomain
  } = React.useContext(FormContext);
  const DropdownField = fieldComponentMap.Dropdown;
  const [countryOptions, setCountryOptions] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  React.useEffect(() => {
    const countryService = new CountryService({
      apiUrl: apiDomain,
      culture
    });
    setIsLoading(true);
    countryService.getDataForSelectOptions().then(countries => {
      setCountryOptions(countries);
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  }, [apiDomain, culture, setCountryOptions]);
  const handleSetStateValue = React.useCallback(value => {
    const selectedOption = countryOptions.filter(option => option.value === value)[0];
    const title = selectedOption && selectedOption.title;
    setValue(value, title);
  }, [countryOptions, setValue]);
  return React__default.createElement(DropdownField, {
    isLoading: isLoading,
    fieldId: fieldId,
    name: name,
    placeholder: placeholder,
    label: label,
    options: countryOptions,
    isSearchable: isSearchable,
    hint: hint,
    controlRef: controlRef,
    onClick: onClick,
    setValue: handleSetStateValue,
    value: value,
    error: error,
    errorMessage: errorMessage,
    type: "Dropdown",
    disabled: disabled,
    required: required,
    hidden: hidden
  });
});

class StateApi extends BaseApi {
  constructor(config) {
    super(config);
  }
  // Load states info form GET /api/location/countries/{code}/divisions
  loadStatesInfo(countryCode) {
    const params = {
      countryCode
    };
    return this.getData(params).then(data => {
      return data;
    });
  }
  callApi(url, params) {
    const divisionsUrl = `${new URL(url).origin}${StateApi.API_PATH}/${params.countryCode}/${StateApi.API_KEY_WORD}`;
    const additionalParams = params.language ? {
      language: params.language
    } : null;
    return super.callApi(divisionsUrl, additionalParams);
  }
  serialize(data, params) {
    const states = data.value;
    if (!states || states.length < 1) {
      return null;
    }
    if (this.canUseStorage()) {
      const retrievedStatesJSON = this.storageWithExpiration.getDataFromStorage(this.config.storageKey);
      const allStates = retrievedStatesJSON ? safeJSONParse(retrievedStatesJSON) : {};
      if (allStates) {
        allStates[params.countryCode] = data;
        return JSON.stringify(allStates);
      }
    }
    return null;
  }
  deserialize(data, params) {
    if (!data) {
      return null;
    }
    const allStates = safeJSONParse(data);
    if (allStates && allStates[params.countryCode]) {
      return allStates[params.countryCode];
    }
    return null;
  }
}
StateApi.API_KEY_WORD = 'divisions';
StateApi.API_PATH = '/api/location/countries';

class StatesService extends BaseLocationService {
  get serviceName() {
    return 'StatesService';
  }
  constructor(config) {
    super(config);
    this.storageKey = 'statesInfo';
    this.getDataForSelectOptions = countryCode => {
      return this.getData(countryCode).then(states => {
        const result = this.mapItemsToUIModel(states);
        if (result) {
          result.sort(getStringCompareFunction('title'));
        }
        return result;
      });
    };
    this.getData = countryCode => {
      const apiCountryCode = this.parseCountryCode(countryCode);
      return this.stateApi.loadStatesInfo(apiCountryCode).then(this.mapStatesApiDataToLocationInfoModel);
    };
    this.mapStatesApiDataToLocationInfoModel = data => {
      const states = data.value;
      return states.map(state => {
        return {
          code: state.id,
          name: state.name
        };
      });
    };
    this.stateApi = new StateApi({
      storage: sessionStorage,
      storageKey: this.createDefaultStorageKey(this.storageKey),
      url: config.apiUrl
    });
  }
}

const StateField = React.memo(({
  fieldId,
  name,
  placeholder,
  label,
  hint,
  setValue,
  onClick,
  value = '',
  error,
  errorMessage,
  relatedFieldId,
  disabled,
  required,
  isSearchable,
  hidden,
  controlRef
}) => {
  var _formData$relatedFiel;
  const {
    fieldComponentMap,
    apiDomain,
    culture
  } = React.useContext(FormContext);
  const DropdownField = fieldComponentMap.Dropdown;
  const stateService = React.useMemo(() => new StatesService({
    apiUrl: apiDomain,
    culture
  }), [apiDomain, culture]);
  const [stateOptions, setStateOptions] = React.useState([]);
  const [isStatesLoading, setIsStatesLoading] = React.useState(false);
  const formData = useReduxState(state => state.form.formData);
  const country = formData === null || formData === void 0 ? void 0 : (_formData$relatedFiel = formData[relatedFieldId]) === null || _formData$relatedFiel === void 0 ? void 0 : _formData$relatedFiel.value;
  React.useEffect(() => {
    if (!country) return;
    setIsStatesLoading(true);
    stateService.getDataForSelectOptions(country).then(states => {
      setStateOptions(states);
      setIsStatesLoading(false);
    }).catch(() => {
      setIsStatesLoading(false);
    });
  }, [country, stateService]);
  const handleSetStateValue = React.useCallback(value => {
    const selectedOption = stateOptions.filter(option => option.value === value)[0];
    const title = selectedOption && selectedOption.title;
    setValue(value, title);
  }, [stateOptions, setValue]);
  return React__default.createElement(DropdownField, {
    isLoading: isStatesLoading,
    fieldId: fieldId,
    name: name,
    placeholder: placeholder,
    label: label,
    options: stateOptions,
    hint: hint,
    isSearchable: isSearchable,
    controlRef: controlRef,
    onClick: onClick,
    setValue: handleSetStateValue,
    value: value,
    error: error,
    errorMessage: errorMessage,
    type: "Dropdown",
    disabled: disabled || !country,
    required: required,
    hidden: hidden
  });
});

const customFieldComponentMap = {
  Country: CountryField,
  State: StateField
};

function FormProvider({
  fieldComponentMap,
  culture,
  apiDomain,
  children
}) {
  const [formId] = React.useState(createRandomId());
  const providedValues = {
    formId,
    fieldComponentMap,
    culture,
    apiDomain
  };
  return React__default.createElement(FormContext.Provider, {
    value: providedValues
  }, children);
}

function setFormFieldDisplayStates({
  form,
  formData
}) {
  const fieldStates = {};
  formsServiceUiValidation.forEachField(form, field => {
    fieldStates[field.fieldId] = field.displayCondition ? formsServiceUiValidation.getDisplayState(field.displayCondition, formData) : formsServiceUiTypes.FieldDisplayStates.Visible;
  });
  return fieldStates;
}

produce.enableES5();
const defaultFormState = {
  formData: {},
  errors: [],
  submitting: false,
  form: null,
  loadingForm: true,
  fieldStates: {},
  lastAction: null
};
function formDataReducer(state = defaultFormState, action) {
  return produce__default(state, newState => {
    switch (action.type) {
      case FORM_LOADED:
        {
          const {
            form
          } = action.payload;
          formsServiceUiValidation.forEachField(form, field => {
            if (state.fieldStates[field.fieldId] === formsServiceUiTypes.FieldDisplayStates.Visible) {
              newState.formData[field.fieldId] = {
                name: field.name,
                value: field.defaultValue
              };
            }
          });
          newState.loadingForm = false;
          newState.form = form;
          newState.errors = [];
          newState.fieldStates = setFormFieldDisplayStates({
            form: newState.form,
            formData: newState.formData
          });
          break;
        }
      case FORM_LOAD_ERROR:
        {
          newState.loadingForm = false;
          newState.form = null;
          newState.errors = [];
          break;
        }
      case SET_VALUE:
        {
          const {
            field,
            value,
            title
          } = action.payload;
          const {
            name,
            fieldId
          } = field;
          newState.lastAction = UserActions.FormControlValueChange;
          newState.formData[fieldId] = _objectSpread2({
            name,
            value
          }, title && {
            title
          });
          newState.errors = state.errors.filter(e => e.fieldId !== fieldId);
          handleDependantFieldsUpdate(newState, field);
          newState.fieldStates = setFormFieldDisplayStates({
            form: newState.form,
            formData: newState.formData
          });
          removeHiddenFieldsFromState(newState);
          removeErrorsOfHiddenFields(newState);
          break;
        }
      case SET_VALIDATION_ERRORS:
        {
          newState.lastAction = UserActions.Submit;
          newState.errors = action.payload.errors;
          break;
        }
      case FORM_SUBMIT_RESPONSE_RECEIVED:
        {
          const {
            errors,
            success,
            workflowSuccess
          } = action.payload;
          newState.lastAction = UserActions.Submit;
          newState.submitting = false;
          newState.errors = errors || [];
          newState.workflowError = !success && !workflowSuccess;
          if (success) {
            newState.formData = {};
          }
          break;
        }
      case SUBMITTING_FORM_DATA:
        {
          newState.submitting = true;
          break;
        }
    }
  });
}
function handleDependantFieldsUpdate(newState, field) {
  if (field.type === 'Country') {
    newState.formData[field.relatedFieldId] = undefined;
  }
}
function removeHiddenFieldsFromState(newState) {
  Object.keys(newState.fieldStates).forEach(fieldId => {
    if (newState.fieldStates[fieldId] === formsServiceUiTypes.FieldDisplayStates.Hidden) {
      delete newState.formData[fieldId];
    }
  });
}
function removeErrorsOfHiddenFields(newState) {
  newState.errors = newState.errors.filter(e => newState.fieldStates[e.fieldId] !== formsServiceUiTypes.FieldDisplayStates.Hidden);
}

const rootReducer = redux.combineReducers({
  form: formDataReducer
});
const createReduxStore = () => redux.createStore(rootReducer);

const _excluded = ["culture", "fieldComponentMap", "apiDomain"];
function Form(_ref) {
  let {
      culture,
      fieldComponentMap,
      apiDomain
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const mergedFieldComponentMap = React.useMemo(() => merge(_objectSpread2(_objectSpread2({}, customFieldComponentMap), fieldComponentMap)), [fieldComponentMap]);
  const [store] = React.useState(createReduxStore());
  return React__default.createElement(reactRedux.Provider, {
    store: store
  }, React__default.createElement(FormProvider, {
    apiDomain: apiDomain,
    fieldComponentMap: mergedFieldComponentMap,
    culture: culture
  }, React__default.createElement(RenderForm, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    apiDomain: apiDomain,
    culture: culture
  }))));
}

exports.Form = Form;
exports.FormContext = FormContext;
exports.RenderForm = RenderForm;
exports.getFormAlias = getFormAlias;
exports.isNonEmptyRow = isNonEmptyRow;
exports.processFormData = processFormData;
//# sourceMappingURL=index.js.map
